/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Resource search-select and team checkbox picker used on edit pages.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {AppSharedModule} from '../app-shared.module';
import {AdnSelectModule} from '../directives/adn-select/adn-select.module';
import {SearchSelectComponent} from './search-select.component';
import {AdnTeamSelectorComponent} from './team-selector.component';

const SEARCH_SELECT = [
  SearchSelectComponent,
  AdnTeamSelectorComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    AdnSelectModule
  ],
  declarations: SEARCH_SELECT,
  exports: SEARCH_SELECT
})
export class SearchSelectModule {
}
